import { useLiveQuery } from "dexie-react-hooks";
import { db } from "../../Utils/Functions/Dexie-Setup";
import { useState, useEffect, useRef, useMemo } from "react";

const TextMultiLineInput = ({tableName, primaryKey, fieldName, label, resizeHint, ...rest}) => {
    const record = useLiveQuery(() => db[tableName].get(primaryKey), [primaryKey, tableName]);
    const [value, setValue] = useState("");
    const updatedAt = useRef(0);
    const timeout = useRef("");
    const textareaRef = useRef(null);
    const recordType = useMemo(() => String, []);
    const inputType = useMemo(() => String, []);



    const setTextareaHeight = (textarea) => {
        if (!textarea) return;
        textarea.style.height = "auto";
        textarea.style.height = `${Math.max(textarea.scrollHeight, 200)}px`;
    };


    const onChange = (e) => {
        updatedAt.current = Date.now();
        setValue(e.target.value); 
        setTextareaHeight(e.target);
        clearTimeout(timeout.current);
        timeout.current = setTimeout(() => {
            db[tableName].update(primaryKey, {[fieldName]: recordType(e.target.value), locallyUpdatedAt: Date.now()})
        }, 150);
    }


    useEffect(() => {
        if(record !== undefined) {

            if(!updatedAt.current || updatedAt.current < record.locallyUpdatedAt) {
                setValue(record[fieldName] ? inputType(record[fieldName]) : "" );
            }
        }
    }, [record, fieldName, inputType])

    useEffect(() => {
        setValue("");
        updatedAt.current = 0;
        clearTimeout(timeout.current)
        timeout.current = "";
    }, [tableName, primaryKey, fieldName])

    useEffect(() => {
        setTextareaHeight(textareaRef.current);
    }, [value]);
    


    return (
        <>
            <label htmlFor={`${primaryKey}-${fieldName}`} className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">{label}</label>
            <textarea
                rows={8}
                ref={textareaRef}
                value={value}
                onChange={onChange}
                id={`${primaryKey}-${fieldName}`}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-base md:text-sm leading-6 rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-3 resize-y min-h-[200px] overflow-y-hidden dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                {...rest}
            />
            {resizeHint && !rest.disabled ? (
                <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">{resizeHint}</p>
            ) : null}
        </>
    )
}

export default TextMultiLineInput
